<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      class="storageOrderEdit"
      :title="disabled ? '详情' : pkid > 0 ? '编辑' : '新建 '"
      :close-on-click-modal="false"
      width="1000px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="filter"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="pkid > 0" :span="12">
          <el-form-item label="入库单号" prop="billNo">
            <el-input v-model="filter.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联单号" prop="relBillNo">
            <el-input v-model="filter.relBillNo" placeholder="请输入关联单号" clearable>
              <el-button v-if="!disabled" slot="append" @click="$refs.OrderSelect.open()"> 选择 </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入库类型" prop="inStockType">
            <el-select v-model="filter.inStockType" disabled clearable>
              <el-option label="生产入库" :value="1"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="pkid > 0" :span="12">
          <el-form-item label="到货日期">
            <el-date-picker
                v-model="filter.receiptDate"
                type="date"
                style="width:100%"    
                value-format="yyyy-MM-dd HH:mm:ss"/>
          </el-form-item>
        </el-col>
        <el-col v-if="pkid > 0" :span="12">
          <el-form-item label="制单时间">
            <el-input v-model="filter.createTime" disabled/>
          </el-form-item>
        </el-col>   
        <el-col v-if="pkid > 0" :span="12">
          <el-form-item label="制单人">
            <el-input v-model="filter.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="filter.note" type="textarea" autosize placeholder="请填写备注"/>
          </el-form-item>
        </el-col>   
      </el-row>     
      <div class="editTitle">入库明细</div>
      <el-table
          class="tableBox"
          :data="filter.details"
          border>
        <el-table-column
            prop="materialNo"
            align="center"
            label="物料编号"
            show-overflow-tooltip
            width="140"/>
        <el-table-column
            prop="materialName"
            align="center"
            label="物料描述"
            show-overflow-tooltip
            width="360"/>
        <!-- <el-table-column prop="specification" align="center" label="规格型号" width="120"/> -->
        <el-table-column prop="unitName" align="center" label="单位" width="60"/>
        <el-table-column align="center" label="数量" width="100" prop="quantity">
          <template slot-scope="scope">
            <el-form-item :prop="'details.' + scope.$index + '.quantity'" :rules="ruleValidate.quantity">
              <el-input v-model="scope.row.quantity" placeholder="请输入"/>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column align="center" label="库位" min-width="200">
          <template slot-scope="scope">
            <el-form-item :prop="'details.' + scope.$index + '.locationName'" :rules="ruleValidate.locationName">
              <el-input v-model="scope.row.locationName" clearable placeholder="请选择">
                <el-button v-if="!disabled" slot="append" @click="$refs.warehouseSelect.open(),setIndex(scope.$index)"> 选择 </el-button>
              </el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="note" align="center" label="备注" width="150">
          <template slot-scope="scope">
            <el-input 
                v-model.trim="scope.row.note"
                type="textarea"
                autosize
                placeholder="请输入备注"/>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <prodution-order-select ref="OrderSelect" @select="OrderSelect"/>
    <warehouse-select ref="warehouseSelect" @select="kwSelect"/>
    <div slot="footer">
      <el-button size="mini" @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" type="primary" size="mini" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import ProdutionOrderSelect from "../../ProductionManagement/ProductionOrder/ProductionOrderSelect.vue";
  import WarehouseSelect from "@/views/information/WarehouseNew/WarehouseSelect";
  export default {
    name:"ProductionStorageEdit",
    components:{ ProdutionOrderSelect, WarehouseSelect},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        disabled:false,
        pkid: "",
        index: 0,
        options:[],
        filter:{
          billNo:"",
          relBillNo:"",
          inStockType:1,
          supplierId:"",
          status:0,
          supplierName:"",
          receiptDate:"",
          createTime:"",
          creatorName:"",
          details:[],
        },
        ruleValidate:{
          relBillNo:{required:true,message:"请输入关联单号", tirgger: "blur"},
          inStockType: {required:true,message:"请选择入库类型"},
          quantity:{required:true, trigger: "blur"},
          locationName:{required:true, trigger: "blur"},
        },
      };
    },
    methods: {
      //页面开启
      open(id,disabled) {
        console.log(id);
        this.pkid = id;
        this.dialogVisible = true;
        if (this.pkid > 0) {
          this.getData();
        }else {
          this.getBillNo();
        }
        if(disabled) {
          this.disabled = true;
        }
      },

      //获取下一个可用的订单号
      getBillNo() {
        this.$http.get("basic","inStockBills/genBillNO").then((res)=>{
          this.filter.billNo = res.data;
        }).catch(()=>{

        });
      },

      //获取详情行索引值
      setIndex(val) {
        console.log(val);
        this.index = val;
      },

      //库位选择
      kwSelect(row) {
        console.log(row);
        this.filter.details[this.index].locationId = row.pkid;
        this.filter.details[this.index].locationName = row.name;
      },

      //编辑时获取已有数据
      getData() {
        this.$http.get("basic",`inStockBills/${this.pkid}`).then((res)=>{
          console.log(res);
          this.filter = res.data;
        });
      },

      //选择关联生产工单
      OrderSelect(row) {
        console.log(row);
        this.filter.relBillNo = row.billNo;
        let orderDetail = {
          materialId: row.materialId,
          materialNo: row.materialNo,
          locationId:"",
          locationName:"",
          materialName: row.materialName,
          quantity: row.quantity,
          unitName: row.unitName,
          specification: row.specification,
        };
        this.filter.details = [],
        this.filter.details.push(orderDetail);
      },

      //提交表单数据
      handleSubmit() {
        console.log(this.filter);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "inStockBills", this.filter)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.storageOrderEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.storageOrderEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.storageOrderEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.storageOrderEdit .el-divider--horizontal {
  margin: 10px 0;
}

.storageOrderEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

// 加载效果水平垂直居中
.el-loading-spinner {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
}
// 标题
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}
.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
